import { ArrowUpRight, Box, Layers, Shield, ArrowRight, Download, CircleDot } from "lucide-react";
import products from './productData';

const getProductIcon = (name) => {
  if (name.includes("Coil")) return <CircleDot className="w-8 h-8 text-accent mb-4" />;
  if (name.includes("Plate") || name.includes("Sheet")) return <Layers className="w-8 h-8 text-accent mb-4" />;
  return <Box className="w-8 h-8 text-accent mb-4" />;
};

function ProductGrid() {
  return (
    <div id="products" className="bg-light py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-accent font-bold tracking-wide uppercase text-sm mb-3">Our Products</h2>
          <h3 className="text-3xl md:text-5xl font-bold font-heading text-primary mb-6">
            Engineered for Excellence
          </h3>
          <p className="text-slate-600 text-lg">
            We supply a wide range of premium steel products sourced from top manufacturers like SAIL, ensuring durability and reliability for every project.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, idx) => (
            <a
              key={idx}
              href="#contact"
              className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-accent/20 relative overflow-hidden block"
            >
              <div className="absolute top-0 right-0 p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <ArrowUpRight className="text-accent w-6 h-6" />
              </div>

              <div className="transform group-hover:-translate-y-1 transition-transform duration-300">
                {getProductIcon(product.name)}
                <h3 className="text-xl font-bold text-primary mb-3 group-hover:text-accent transition-colors">
                  {product.name}
                </h3>
                <p className="text-slate-500 leading-relaxed mb-6">
                  {product.description}
                </p>
                <span className="text-sm font-medium text-accent border-b border-transparent group-hover:border-accent transition-colors inline-block pb-0.5">
                  Request Quote
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="/downloads/brochure.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary text-white rounded-full font-medium hover:bg-accent transition-all shadow-lg hover:shadow-accent/30"
          >
            Download Brochure <Download size={18} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default ProductGrid;
